// extracted by mini-css-extract-plugin
export default {"menu-item":"MenuItem_menu-item__a1-eB","active":"MenuItem_active__H0r8k"};